<template>

    <div class="product_data">
        <table class="table table-borderless">
            <thead>
                <tr>
                    <th colspan="2" scope="rowgroup">
                        {{ techData.type }}
                    </th>
                </tr>
            </thead>
            <tbody class="table-group-divider">
                <tr v-for="(item, i) in techData.values" :key="i">
                    <th scope="row">
                        {{ item.title }}
                    </th>
                    <td class="text-end">
                        {{ item.value }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>
    export default {
        name: 'TechData',
        props: ['techData'],
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
